

































import {
  defineComponent,
  useContext,
  useFetch,
  ref,
} from '@nuxtjs/composition-api'
import { rootNewsCategoryName } from '~/composables/useBlog'
import { NewsItem } from '~/types/blog'

export default defineComponent({
  name: 'BlogNewsArticles',

  props: {
    category: {
      type: String,
      default: 'root',
    },
  },

  setup(props) {
    const pageSize = ref(4)
    const pageOffset = ref(0)
    const total = ref(0)

    const { $api } = useContext()
    const articles = ref<NewsItem[] | null>(null)

    const { fetch } = useFetch(async () => {
      const rootParams = { root: true }

      const defaultParams = {
        limit: pageSize.value,
        offset: pageOffset.value,
      }

      const fetchParams = Object.assign(
        props.category === 'root' ? rootParams : {},
        defaultParams
      )

      const result = await $api.blog.getNewsCategoryByName(
        props.category === 'root' ? rootNewsCategoryName : props.category,
        fetchParams
      )

      if (result) {
        total.value = result.newsItemsCount ?? 0
        articles.value = result.newsItems ?? []
      }
    })

    const onChangePage = (_: number, offset: number) => {
      pageOffset.value = offset
      fetch()
    }

    return {
      articles,
      pageSize,
      pageOffset,
      total,

      onChangePage,
    }
  },
})
